import { STATUS_OK, STATUS_INTERNAL_SERVER_ERROR } from '../constants';

/**
 * Default value for `validateStatus` option to prevent Axios from throwing non-5xx errors.
 */
export const validateStatus = (status: number) => status >= STATUS_OK && status < STATUS_INTERNAL_SERVER_ERROR;
